<script>
export default {};
</script>
<template>
  <div class="gl-flex gl-py-2">
    <div class="gl-border-l gl-ml-2 gl-pl-3"></div>
  </div>
</template>
